import React from "react";
import BgVermelho from "../images/bg-vermelho.png";
import { IoIosArrowDown } from "react-icons/io";
import { useCartao } from "../hooks/cartao";
const Bloco1: React.FC = () => {
  const { passo } = useCartao();
  return (
    <>
      {passo === 0 && (
        <section
          className="pb-96 lg:pb-60"
          style={{
            backgroundImage: `url(${BgVermelho})`,
            backgroundPosition: "top center",
            backgroundSize: "100vw 100vh",
          }}
        >
          <div className="w-full bg-theme2">
            <div
              className="block w-40 h-20 mx-auto rounded-t-full pt-4 justify-center items-center"
              style={{
                backgroundImage: `url(${BgVermelho})`,
                backgroundPosition: "top center",
                backgroundSize: "100vw 100vh",
              }}
            >
              <IoIosArrowDown className="w-16 h-16 text-gray-200 mx-auto" />
            </div>
          </div>
          <div className="container flex flex-col items-center justify-center px-5 py-10 lg:py-16 mx-auto lg:flex-row lg:px-18 2lg:px-28">
            <div className="flex flex-col items-start w-full pt-0 lg:mb-16 text-left lg:flex-grow lg:pr-24 lg:mb-0 lg:px-48">
              <h1 className="mb-2 lg:mb-8 text-2xl font-normal tracking-tight mx-auto text-white lg:text-4xl">
                Para <b className="font-semibold">desbloquear</b> seu cartão?
              </h1>
              <p className="mb-8 text-md lg:text-xl leading-relaxed text-white text-left">
                O cartão Dental Uni deve ser desbloqueado para dar início ao uso
                do plano odontológico. Sem o desbloqueio não é possível receber
                atendimento, já que o dentista não conseguirá lançar suas guias
                em nosso sistema.
              </p>
              <p className="mb-8 text-md lg:text-xl leading-relaxed text-white text-left">
              Portanto, informe seu CPF ou número do cartão nos campos acima e clique em Desbloquear. Caso possua dependente maior de idade, o desbloqueio deverá ser feito pelo próprio dependente. Caso os dependentes sejam menores de idade, o processo ocorrerá juntamente com o desbloqueio do titular.
              </p>
              <p className="mb-8 text-md lg:text-xl leading-relaxed text-white text-left">
              Esse processo irá gerar seu Cartão Virtual, que será enviado para o e-mail cadastrado. O Cartão Virtual é uma grande facilidade para realizar seus atendimentos odontológicos e poderá ser apresentado através do App Minha Dental Uni. 
              </p>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Bloco1;
